import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  typeForEdit: {
    id: undefined,
    name: "",
    expiry_month: "",
    expiry_year: "",
    name_on_Card: "",
    last_4: "",
    isDefault: "",
    email: "",
    city: "",
    country: "",
    line1: "",
    line2: "",
    pincode: "",
    state: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
  typeId: undefined,
  email: "",
  showtypePopover: false,
  showDeleteDialog: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const savedCardSlice = createSlice({
  name: "savedCards",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // category loader
    typeListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    typeList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadtypeForEdit: (state, action) => {
      const payload = action.payload;

      state.typeForEdit.name = payload.metadata.nickName ?? "";
      state.typeForEdit.id = payload.id;
      state.typeForEdit.expiry_month = payload.card.exp_month;
      state.typeForEdit.expiry_year = payload.card.exp_year;
      state.typeForEdit.name_on_Card = payload.billingDetails.name;
      state.typeForEdit.last_4 = payload.card.last4;
      state.typeForEdit.isDefault = payload.defaultPaymentMethod;
      state.typeForEdit.email = payload.billingDetails.email;
      state.typeForEdit.city = payload.billingDetails.address.city;
      state.typeForEdit.country = payload.billingDetails.address.country;
      state.typeForEdit.line1 = payload.billingDetails.address.line1;
      state.typeForEdit.line2 = payload.billingDetails.address.line2;
      state.typeForEdit.pincode = payload.billingDetails.address.postal_code;
      state.typeForEdit.state = payload.billingDetails.address.state;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
    setDeleteDialogData: (state, action) => {
      const { id, email } = action.payload;

      state.showDeleteDialog = !state.showDeleteDialog;
      state.typeId = id;
      state.email = email;
    },
  },
});
